"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../../../chunks/clsx-CBkIpawf.js");
const components_input_elements_unstyled_RadioBase_hooks_useRadioContext = require("./hooks/useRadioContext.js");
const helpers_module = require("../../../../../chunks/helpers.module-CyAR4a3K.js");
const FocusRing_module = require("../../../../../chunks/FocusRing.module-CTvWELtH.js");
const utils = require("../../../../../chunks/utils-DLbQ3blk.js");
const mergeProps = require("../../../../../chunks/mergeProps-AWQ5Mc81.js");
const filterDOMProps = require("../../../../../chunks/filterDOMProps-DSqQIo6b.js");
const useFormValidation = require("../../../../../chunks/useFormValidation-Dodhyml1.js");
const usePress = require("../../../../../chunks/usePress-CQi4MPVm.js");
const useFocusable = require("../../../../../chunks/useFocusable-3KL9EmBS.js");
const useFocusRing = require("../../../../../chunks/useFocusRing-014cPU2v.js");
function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
  let { value, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, onPressStart, onPressEnd, onPressChange, onPress, onPressUp, onClick } = props;
  const isDisabled = props.isDisabled || state.isDisabled;
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel && process.env.NODE_ENV !== "production") console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let checked = state.selectedValue === value;
  let onChange = (e) => {
    e.stopPropagation();
    state.setSelectedValue(value);
  };
  let { pressProps, isPressed } = usePress.$f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    onClick,
    isDisabled
  });
  let { pressProps: labelProps, isPressed: isLabelPressed } = usePress.$f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPressUp,
    onClick,
    isDisabled,
    onPress(e) {
      var _ref_current;
      onPress === null || onPress === void 0 ? void 0 : onPress(e);
      state.setSelectedValue(value);
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }
  });
  let { focusableProps } = useFocusable.$f645667febf57a63$export$4c014de7c8940b4c(mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(props, {
    onFocus: () => state.setLastFocusedValue(value)
  }), ref);
  let interactions = mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = filterDOMProps.$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let tabIndex = -1;
  if (state.selectedValue != null) {
    if (state.selectedValue === value) tabIndex = 0;
  } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
  if (isDisabled) tabIndex = void 0;
  let { name, form, descriptionId, errorMessageId, validationBehavior } = utils.$884aeceb3d67f00f$export$37b65e5b5444d35c.get(state);
  useFormValidation.$99facab73266f662$export$5add1d006293d136(ref, state.defaultSelectedValue, state.setSelectedValue);
  useFormValidation.$e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior
  }, state, ref);
  return {
    labelProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: (e) => e.preventDefault()
    }),
    inputProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      ...interactions,
      type: "radio",
      name,
      form,
      tabIndex,
      disabled: isDisabled,
      required: state.isRequired && validationBehavior === "native",
      checked,
      value,
      onChange,
      "aria-describedby": [
        props["aria-describedby"],
        state.isInvalid ? errorMessageId : null,
        descriptionId
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled,
    isSelected: checked,
    isPressed: isPressed || isLabelPressed
  };
}
const Radio = React.forwardRef(
  ({ selectedClassName, pressedClassName, focusedClassName, className, ...props }, ref) => {
    const radioGroupProps = components_input_elements_unstyled_RadioBase_hooks_useRadioContext.useRadioProvider();
    const { state } = radioGroupProps;
    const inputRef = React.useRef(null);
    const { inputProps, isSelected, isPressed, labelProps } = $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, inputRef);
    const { focusProps, isFocusVisible } = useFocusRing.$f7dceffc5ad7768b$export$4e328f61c538687f();
    return /* @__PURE__ */ jsxRuntime.jsxs(
      "label",
      {
        className: clsx.clsx(className, {
          [selectedClassName || ""]: isSelected,
          [pressedClassName || ""]: isPressed,
          [focusedClassName || ""]: isFocusVisible,
          [FocusRing_module.focus.focusRing]: isFocusVisible
        }),
        ...labelProps,
        id: props.id,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(
            "input",
            {
              ...mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
              ref: ref || inputRef,
              className: helpers_module.helpers.srOnly
            }
          ),
          props.children
        ]
      }
    );
  }
);
exports.Radio = Radio;
